import InvestmentsTable from './investments-table';

export default InvestmentsTable;
